import HomePageContentAPICall from "src/service/HomePageContentAPICall";
import System from "src/helper/system";
import Constants from "src/helper/Constants";
import HomePageDocumentContentAPICall from "src/service/HomePageDocumentContentAPICall";
import ProductListingAPICall from "src/service/ProductListingAPICall";
import store from "../storeWire";
import { getIndividualTabsCount } from "../store/slice/model/HomePageContent"
import { __remove, __set } from "src/store/axios_indicator";
const { homePageAllTabs } = Constants;

class HomePageContentRepository {

    getDocumentCount = async (params) => {
        if (params.currentTab !== homePageAllTabs.DOCUMENT.abbr) {
            const resFromDoc = await new HomePageDocumentContentAPICall().getDocumentList({
                search: params.searchParam,
                skip: 0, top: 0, orderby: "DocumentType asc"
            });
            store.dispatch(getIndividualTabsCount({ "docCount": resFromDoc?.data?.count || 0 }))
        }
    }

    getContentTabsCount = async (params) => {
        __set('ALL_CONTENT_COUNT_API_CALL')
        const res = await new HomePageContentAPICall().getContentTabCount({ searchTerm: params.searchParam });
        let contentCnt = {
            "articleCount": res?.articles || 0,
            "siteCount": res?.sitePages || 0,
            "eventCount": res?.events || 0,
            "videoCount": res?.video || 0,
            "allContentCount": res?.all || 0,
            "npiCount": res?.npi || 0
        }

        store.dispatch(getIndividualTabsCount(contentCnt))
        __remove("ALL_CONTENT_COUNT_API_CALL")
    }

    getProductTabCount = async (params) => {
        if (params.currentTab !== homePageAllTabs.PRODUCT.abbr) {
            const speedBoat = System.avUserInfoData.speedBoatAbbr;
            const SboatF = "Sboat eq '" + speedBoat + "'";
            const resProduct = await new ProductListingAPICall().getListData({
                search: params.searchParam,
                top: 0, skip: 0,
                isIncludeCount: true,
                isProductImageInclude: false,
                isSkipFacets: true,
                filter: SboatF
            });
            store.dispatch(getIndividualTabsCount({ "productListingCount": resProduct?.productCount || 0 }))
        }
    }

    getHomePageContent = async (params) => {
        let res = await new HomePageContentAPICall().getHomePageContent(params);
        let data = []
        if (res?.data?.webContentView) {
            res.data.webContentView = res.data.webContentView.map(item => {
                if (item.url) {
                    if (params.contentType !== homePageAllTabs.VIDEO.contentType && item.avnPageType !== homePageAllTabs.VIDEO.pageType) {
                        item.url = System.getRedirectionURL(item.url.replace(/^.*\/\/[^\/]+\/wps\/portal\/us/, ''));
                    } else {
                        item.url = item.url.replace("http://", "https://")
                    }
                }

                return item;
            });
        }
        data[params.contentType] = res?.data
        return data
    };
}

export default HomePageContentRepository;